import { render, staticRenderFns } from "./OrderCardRenderer.vue?vue&type=template&id=22628c0c&scoped=true"
import script from "./OrderCardRenderer.vue?vue&type=script&lang=js"
export * from "./OrderCardRenderer.vue?vue&type=script&lang=js"
import style0 from "./OrderCardRenderer.vue?vue&type=style&index=0&id=22628c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22628c0c",
  null
  
)

export default component.exports